import MuiTypography, {TypographyProps} from '@mui/material/Typography';

export const Typography = (props: TypographyProps) => {
    return <MuiTypography {...props} />
}